var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn_graylineW fr icon_l_btn",attrs:{"href":_vm.downloadLink,"target":"_blank","role":"button"}},[_c('i',{staticClass:"icon_download"}),_vm._v("다운로드")])
}
var staticRenderFns = []

export { render, staticRenderFns }